export const HasForceReRenderMixin = {
  data() {
    return {
      renderKey: 0,
      renderKeys: []
    };
  },
  methods: {
    reRender(key = null) {
      key
        ? this.$set(this.renderKeys, key, (this.renderKeys[key] ?? 0) + 1)
        : (this.renderKey += 1);
    },
    getRenderKey(key = null) {
      return key ? this.renderKeys[key] ?? 0 : this.renderKey;
    }
  }
};
